<script lang="ts">
  import { cn } from "@/lib/utils";
    import { format } from "date-fns";

    export let focusPowerDuration: number
    export let currentFocusPower: number
    export let projectedFocusPower: number
    export let date: Date
    export let planSaved: boolean = false
    let className:string = undefined
    export {className as class}
</script>

<div class={cn("flex flex-wrap gap-1 text-base text-left items-baseline leading-none", className)}>
    <span>
        {planSaved ? "Increasing" : "Increase"} the maximum power you can hold for <span class="font-bold">{focusPowerDuration} minutes.</span>
    </span>
    <div class="">
        <span class="text-slate-600">From </span>
        <span class="font-bold text-2xl mx-1 leading-none tracking-tight">{Math.round(currentFocusPower)}<span class="text-slate-500 font-normal text-base">w</span></span>
        <span class="text-slate-600"> to </span>
        <span class="font-bold text-2xl mx-1 leading-none tracking-tight">{Math.round(projectedFocusPower)}<span class="text-slate-500 font-normal text-base">w</span></span>
        <span class="text-slate-600"> by </span>
        <span class="font-bold text-lg ml-1 leading-none tracking-tight">{format(date, "LLLL dd, yyyy")}</span>.
    </div>    
</div>